




















import { Vue, Component } from "vue-property-decorator";
import { EventBus } from "@/event-bus";

function formatSurchargePercent(value: string): string {
  const num = parseFloat(value);
  if (isNaN(num) || num <= 0) return "";
  return `${(num * 100).toFixed(0)}%`;
}

const STORAGE_KEY = "surcharge_banner_dismissed";

@Component
export default class SurchargeBanner extends Vue {
  private dismissed = false;

  private surchargeValue: string = formatSurchargePercent(
    process.env.VUE_APP_PRICE_SURCHARGE_VALUE_NUMBER || ""
  );
  private surchargeDate: string =
    process.env.VUE_APP_PRICE_SURCHARGE_DATE || "";

  created() {
    this.dismissed = sessionStorage.getItem(STORAGE_KEY) === "true";
  }

  get visible(): boolean {
    return !this.dismissed && !!this.surchargeValue && !!this.surchargeDate;
  }

  dismiss(): void {
    this.dismissed = true;
    sessionStorage.setItem(STORAGE_KEY, "true");
    EventBus.$emit("surchargeBannerDismissed");
  }
}
